import { render } from "./SettingProfile.vue?vue&type=template&id=78ef37c2&scoped=true&ts=true"
import script from "./SettingProfile.vue?vue&type=script&lang=ts"
export * from "./SettingProfile.vue?vue&type=script&lang=ts"

import "./SettingProfile.vue?vue&type=style&index=0&id=78ef37c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ef37c2"]])

export default __exports__